import VideoModal from 'shared/components/DemoVideoModal/VideoModal';
import React, { useEffect, useState } from 'react';
import OrganizationModal from '../OrganizationModal';
import { Spin, Row, Col } from 'antd';
import Man from 'assets/images/company_men.svg';
import styles from './demoVideoModal.module.scss';
import { DemoVideoTypes } from 'enums/demoVideoEnums';
import { ReactComponent as Play } from 'assets/icons/playVideo.svg';
import DemoVideoService from 'services/DemoVideoService/demoVideo.service';

interface DemoVideoModalProps {
  showVideo: boolean; 
  setShowVideo: (value: boolean) => void;
}

const DemoVideoModal = ({ showVideo, setShowVideo }: DemoVideoModalProps) => {
    const { fetchDemoVideoLink, loading, demoVideos } =
    DemoVideoService();
  const [playVideo, setPlayVideo] = useState<boolean>(false);
  const [selectedVideo, setSelectedVideo] = useState<string>();
  useEffect(() => {
    if (showVideo) {
      fetchDemoVideoLink();
    }
  }, [showVideo]);
  const toggleVideoDisplay = () => setPlayVideo(prev => !prev);
  const closeVideoModal = () => setShowVideo(false);
  const videoData = demoVideos?.map(item => {
    const { title, description, url: videoUrl, type } = item;
    return {
      title,
      description,
      thumbNailUrl: Man,
      videoUrl,
      type,
    };
  });
  const handleOpenVideo = (url?: string, type?: DemoVideoTypes) => () => {
    setSelectedVideo(url ?? '');
    toggleVideoDisplay();
  };
  const helpVideosContent = (
    <Spin spinning={loading}>
      <Row className={styles.videosContainer} gutter={[0, 40]} align="middle">
        {videoData?.map((video, index) => (
          <Col
            span={24}
            key={`video${index}`}
            onClick={handleOpenVideo(video?.videoUrl, video?.type)}
            className={styles.videoContentWrapper}>
            <Row gutter={[15, 15]} align="middle">
              <Col span={8} className={styles.thumbnailContainer}>
                <img
                  src={video.thumbNailUrl}
                  alt={video.title}
                  className={styles.videoThumbnail}
                />
                <Play className={styles.playIcon} />
              </Col>
              <Col span={16}>
                <Row gutter={[15, 5]}>
                  <Col span={24} className={styles.videoTitle}>
                    {video.title}
                  </Col>
                  <Col span={24} className={styles.videoDescription}>
                    {video.description}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </Spin>
  );

  return (
    <div>
      <OrganizationModal
        onClose={closeVideoModal}
        visible={showVideo}
        wrapClassName={styles.demoVideo}
        width={471}
        title="Help"
        children={helpVideosContent}
      />
      <VideoModal
        isOpen={playVideo && !!selectedVideo}
        videoUrl={selectedVideo ?? ''}
        onClose={toggleVideoDisplay}
      />
    </div>
  );
};

export default DemoVideoModal;
